import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DataService } from './data.service';
var BaseHttpService = (function () {
    function BaseHttpService(http, _data) {
        this.http = http;
        this._data = _data;
        this.apiUrl = window.location.protocol + '//' + window.location.host + '/api/';
    }
    BaseHttpService.prototype.getAuthHeaders = function () {
        return {
            headers: new HttpHeaders({
                'Authorization': "Bearer " + this._data.token
            })
        };
    };
    BaseHttpService.prototype.get = function (endpoint) {
        return this.http.get("" + this.apiUrl + endpoint, this.getAuthHeaders());
    };
    BaseHttpService.prototype.post = function (endpoint, body) {
        return this.http.post("" + this.apiUrl + endpoint, body, this.getAuthHeaders());
    };
    BaseHttpService.prototype.put = function (endpoint, body) {
        return this.http.put("" + this.apiUrl + endpoint, body, this.getAuthHeaders());
    };
    BaseHttpService.prototype.delete = function (endpoint) {
        return this.http.delete("" + this.apiUrl + endpoint, this.getAuthHeaders());
    };
    return BaseHttpService;
}());
export { BaseHttpService };
